import { resolveMaterialMechanicalProperty } from './materialMechanicalProperty';

export function createDuplicateMaterialDraft(source = {}) {
  const property = resolveMaterialMechanicalProperty(source);
  return {
    materialName: `${source.materialName || ''} Copy`.trim(),
    otherNames: Array.isArray(source.otherNames) ? source.otherNames.map(name => name) : [],
    mechanicalProperty: property
      ? { value: property.value, scale: property.scale }
      : { value: '', scale: 'MPa_Rm' },
    thermalConductivity: source.thermalConductivity ?? '',
    elongation: source.elongation ?? '',
    chemicalComposition: Array.isArray(source.chemicalComposition)
      ? source.chemicalComposition.map(item => ({ ...item }))
      : [],
    materialGroup: source.materialGroup ?? '',
    coefficients: source.coefficients && typeof source.coefficients === 'object'
      ? { ...source.coefficients }
      : { Vc: '', Fz: '', Ap: '', Ae: '' },
    materialDescription: source.materialDescription ?? '',
    isChecked: false,
  };
}
